import request from '@/utils/request'

export function versionKontrol () {
  return request({
    url: '/version',
    method: 'GET'
  })
}
